package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.*
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import waldo.sankan.lineamunicipalkmp.model.DelitoTipificado
import kotlinx.browser.window

@Composable
fun GestionDelitosScreen(viewModel: AdminPanelViewModel, onBack: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    
    // --- ¡UNIFICACIÓN DE ARSENAL! ---
    val delitos = remember(uiState.delitosCatalog, uiState.daoCatalog) {
        uiState.delitosCatalog + uiState.daoCatalog
    }

    // --- ¡LLAVES DE AUTORIDAD! (Definidas correctamente) ---
    val rolesDAO = listOf("DIRECCION_DAO", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO")
    val rolDB = (uiState.rolAdmin?.rol ?: "").uppercase().trim()
    val uidRolAdmin = uiState.rolAdmin?.uidRol
    val esSeguridad = rolDB == "SEGURIDAD_ADMIN"
    val esDAO = rolDB in rolesDAO
    val esAdminTotal = rolDB == "GENERAL" || rolDB == "COMUNAL" || rolDB == "OPERADORA"


    // --- ESTADOS DEL FORMULARIO ---
    var nuevoNombre by remember { mutableStateOf("") }
    var familiaSeleccionadaForm by remember { mutableStateOf("") }
    var nuevaFamiliaInput by remember { mutableStateOf("") }
    val modoNuevaFamilia = familiaSeleccionadaForm == "NUEVA"

    // --- ESTADO DE NAVEGACIÓN (BRÚJULA DE VISTA) ---
    var familiaSeleccionadaVista by remember { mutableStateOf<String?>(null) }

    // --- FILTRADO DE FAMILIAS (Solo lo que el usuario puede mandar) ---
    val familiasExistentes = remember(delitos, rolDB) {
        delitos.map { it.familia.uppercase().trim() }
            .distinct()
            .filter { it.isNotBlank() }
            .filter { f ->
                when {
                    esAdminTotal -> true // Admin General, Comunal y Operadora ven TODO
                    esSeguridad -> f !in listOf("ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO", "SALVAVIDAS", "SOCIAL", "ADULTO_MAYOR", "EMERGENCIA")
                    esDAO -> {
                        if (rolDB == "DIRECCION_DAO") {
                            // El Jefe ve todo el abanico DAO
                            f in listOf("ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO")
                        } else {
                            // Mapeo flexible para sub-servicios DAO
                            val match = when(rolDB) {
                                "ASEO", "BASURA" -> f == "ASEO" || f == "BASURA"
                                "BACHE" -> f == "BACHE"
                                "ILUMINACION" -> f == "ILUMINACION"
                                "SEMAFORO" -> f == "SEMAFORO"
                                "AUTO_ABANDONADO" -> f == "AUTO_ABANDONADO"
                                else -> f == rolDB
                            }
                            match
                        }
                    }
                    rolDB == "SALVAVIDAS" -> f == "SALVAVIDAS"
                    rolDB == "SOCIAL_ADMIN" -> f == "SOCIAL"
                    rolDB == "SEGURIDAD_ADULTO_MAYOR" -> f == "ADULTO_MAYOR"
                    rolDB == "EMERGENCIA_CARRETERA" -> f == "EMERGENCIA"
                    else -> f == rolDB
                }
            }
            .sorted()
    }

    val delitosFiltrados = remember(familiaSeleccionadaVista, delitos) {
        if (familiaSeleccionadaVista == null) emptyList<DelitoTipificado>()
        else delitos.filter { it.familia.uppercase().trim() == familiaSeleccionadaVista }
    }





    // --- CONTENEDOR PRINCIPAL ---
    Div({
        style {
            display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
            property("height", "calc(100vh - 40.px)"); width(100.percent)
            boxSizing("border-box"); fontFamily("sans-serif")
        }
    }) {

        // --- FILA 1: ENCABEZADO Y RECLUTAMIENTO ---
        Div({
            style {
                display(DisplayStyle.Flex); width(100.percent); backgroundColor(Color("#1976D2"))
                property("border-bottom", "2px solid #1565C0"); boxSizing("border-box")
            }
        }) {
            // Logo y Título (15%)
            Div({
                style {
                    width(15.percent); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
                    alignItems(AlignItems.Center); padding(24.px); boxSizing("border-box")
                }
            }) {
                Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(8.px) } }) {
                    Img(src = "logo_icon.svg", attrs = { style { height(80.px) } })
                    H2({ style { fontSize(20.px); color(Color.white); margin(0.px) } }) {
                        Span({ style { fontWeight("normal") } }) { Text("Linea") }
                        Span({ style { fontWeight("bold") } }) { Text("Muni") }
                    }
                    P({ style { fontSize(14.px); color(Color("#FB8C00")); fontWeight("bold"); margin(0.px) } }) { Text("SMART CITY") }
                }
            }

            // Título Central y Herramientas (85%)
            Div({
                style {
                    flex(1); padding(20.px); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column)
                    gap(24.px); boxSizing("border-box")
                }
            }) {
                H1({
                    style { color(Color.white); fontSize(28.px); fontWeight(700); textAlign("center"); margin(0.px) }
                }) { Text(if (esSeguridad) "ADMINISTRACIÓN DEL CATÁLOGO DE DELITOS" else "ADMINISTRACIÓN DE TIPIFICACIONES URBANAS") }





                // --- BARRA DE RECLUTAMIENTO ---
                Div({
                    style {
                        display(DisplayStyle.Flex); flexDirection(FlexDirection.Row); gap(12.px); padding(18.px)
                        backgroundColor(Color("#f2f2f2")); borderRadius(8.px); border(1.px, LineStyle.Solid, Color("#cccccc"))
                        alignItems(AlignItems.FlexEnd); flexWrap(FlexWrap.Wrap)
                    }
                }) {


                    val esGeneral = (uiState.rolAdmin?.rol ?: "").uppercase() == "GENERAL"

                    if (esGeneral) {
                        Div({
                            style {
                                display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px)
                                padding(16.px); backgroundColor(Color("#E3F2FD")); borderRadius(8.px)
                                marginBottom(12.px); border(1.px, LineStyle.Solid, Color("#2196F3"))
                                width(100.percent); boxSizing("border-box"); flexWrap(FlexWrap.Wrap)
                            }
                        }) {
                            B({ style { color(Color("#1565C0")); fontSize(16.px) } }) { Text("FILTRAR TERRITORIO (MODO ESCALABLE):") }
                            
                            // --- 🌍 FILTRO EN CASCADA ---
                            Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px) } }) {
                                B { Text("REGIÓN:") }
                                Select({
                                    style { padding(8.px); borderRadius(4.px); minWidth(180.px) }
                                    onChange { viewModel.onFiltroRegionChanged(it.target.value) }
                                }) {
                                    Option("", attrs = { if (uiState.filtroRegion == null) selected() }) { Text("-- Seleccione Región --") }
                                    uiState.regiones.forEach { region ->
                                        Option(region.nombre, attrs = { if (uiState.filtroRegion == region.nombre) selected() }) { Text(region.nombre) }
                                    }
                                }
                            }

                            Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px); marginLeft(12.px) } }) {
                                B { Text("COMUNA:") }
                                Select({
                                    style { padding(8.px); borderRadius(4.px); minWidth(200.px) }
                                    onChange { viewModel.onFiltroComunaGestionChanged(it.target.value) }
                                }) {
                                    Option("", attrs = { if (uiState.filtroComunaGestion == null) selected() }) { Text("-- Seleccione Comuna --") }
                                    
                                    val comunasFiltradas = if (uiState.filtroRegion != null) {
                                        uiState.comunas.filter { it.regionDisplayName == uiState.filtroRegion }
                                    } else {
                                        emptyList()
                                    }

                                    comunasFiltradas.map { it.comunaDisplayName }.distinct().sorted().forEach { comuna ->
                                        Option(comuna, attrs = { if (uiState.filtroComunaGestion == comuna) selected() }) { Text(comuna) }
                                    }
                                }
                            }
                        }
                    }

                    // --- FORMULARIO DE CREACIÓN (Habilitado para General si hay filtro de comuna) ---
                    val mostrarFormulario = !esGeneral || uiState.filtroComunaGestion != null

                    if (mostrarFormulario) {
                        // 1. Nombre
                        Div({ style { flex(1); minWidth(200.px) } }) {
                            B({ style { fontSize(16.px) } }) { Text("1. Nombre del Hallazgo:") }
                            Input(type = InputType.Text) {
                                value(nuevoNombre); onInput { nuevoNombre = it.value }
                                placeholder("Ej: Microbasural en esquina")
                                style { display(DisplayStyle.Block); padding(8.px); marginTop(4.px); width(100.percent); boxSizing("border-box"); borderRadius(4.px); border(1.px, LineStyle.Solid, Color.gray) }
                            }
                        }

                        // 2. Familia
                        Div({ style { flex(1); minWidth(200.px) } }) {
                            B({ style { fontSize(16.px) } }) { Text("2. Asignar a Familia:") }
                            Select({
                                style { display(DisplayStyle.Block); padding(8.px); marginTop(4.px); width(100.percent); boxSizing("border-box"); borderRadius(4.px) }
                                onChange { familiaSeleccionadaForm = it.target.value }
                            }) {
                                Option("", attrs = { if (familiaSeleccionadaForm == "") selected() }) { Text("-- Seleccione Familia --") }
                                familiasExistentes.forEach { fam ->
                                    Option(fam, attrs = { if (familiaSeleccionadaForm == fam) selected() }) { Text(fam) }
                                }
                                if (esAdminTotal) {
                                    Option("NUEVA", attrs = { if (familiaSeleccionadaForm == "NUEVA") selected() }) { Text("++ CREAR NUEVA FAMILIA ++") }
                                }
                            }
                        }

                        // 3. Input Nueva Familia
                        Div({
                            style {
                                flex(1); minWidth(200.px)
                                if (!modoNuevaFamilia) opacity(0.4)
                            }
                        }) {
                            B({ style { fontSize(16.px) } }) { Text("3. Nombre Nueva Familia:") }
                            Input(type = InputType.Text) {
                                value(nuevaFamiliaInput); onInput { nuevaFamiliaInput = it.value }
                                if (!modoNuevaFamilia) disabled()
                                style { display(DisplayStyle.Block); padding(8.px); marginTop(4.px); width(100.percent); boxSizing("border-box"); borderRadius(4.px); border(1.px, LineStyle.Solid, if (modoNuevaFamilia) Color("#1976D2") else Color.gray) }
                            }
                        }

                        // 4. Botón de Fuego
                        Button(attrs = {
                            onClick {
                                val famFinal = if (modoNuevaFamilia) nuevaFamiliaInput else familiaSeleccionadaForm
                                if (nuevoNombre.isNotBlank() && famFinal.isNotBlank()) {
                                    val refFinal = uiState.tiposIncidencia.find { it.nombre.uppercase() == famFinal.uppercase() }?.id ?: uidRolAdmin
                                    viewModel.onAgregarNuevoDelitoManual(nuevoNombre, famFinal, refFinal)
                                    nuevoNombre = ""; nuevaFamiliaInput = ""; familiaSeleccionadaForm = ""
                                } else { window.alert("Complete nombre y familia.") }
                            }
                            style { padding(10.px, 20.px); backgroundColor(Color("#34A853")); color(Color.white); border(0.px); borderRadius(6.6.px); cursor("pointer"); fontWeight("bold") }
                        }) { Text("AGREGAR") }
                    }


                    // 5. Botón Cerrar
                    Button(attrs = {
                        onClick { onBack() }
                        style { padding(10.px, 20.px); backgroundColor(Color("#FB8C00")); color(Color.white); border(0.px); borderRadius(6.px); cursor("pointer"); fontWeight("bold") }
                    }) { Text("VOLVER AL PANEL") }
                }
            }
        }

        // --- FILA 2: CUERPO DE OPERACIONES ---
        Div({
            style {
                display(DisplayStyle.Flex); flex(1); marginTop(20.px)
                backgroundColor(Color("#1976D2")); borderRadius(12.px); overflow("hidden")
            }
        }) {
            // Flanco Izquierdo (20%)
            Div({
                style {
                    width(20.percent); backgroundColor(Color.white); padding(24.px)
                    property("border-right", "2px solid #1565C0"); overflowY("auto"); boxSizing("border-box")
                }
            }) {
                B({ style { color(Color.black); fontSize(18.px); fontWeight("bold") } }) { Text("CATEGORÍAS") }
                Hr()
                familiasExistentes.forEach { familia ->
                    val sel = familia == familiaSeleccionadaVista
                    Div({
                        onClick { familiaSeleccionadaVista = familia }
                        style {
                            padding(12.px); fontSize(18.px); fontWeight("bold");
                            marginBottom(4.px); borderRadius(6.px); cursor("pointer")
                            backgroundColor(if (sel) Color("#1976D2") else Color.transparent)
                            color(if (sel) Color.white else Color.black)
                        }
                    }) { Text(familia) }
                }
            }

            // Flanco Derecho (80%)
            Div({
                style { flex(1); padding(32.px); overflowY("auto"); boxSizing("border-box") }
            }) {
                if (familiaSeleccionadaVista == null) {
                    H2({ style { color(rgba(255, 255, 255, 0.6)); textAlign("center"); paddingTop(100.px) } }) {
                        Text("Seleccione una categoría para gestionar")
                    }
                } else {
                    H2({ style { color(Color.white); marginBottom(24.px); fontWeight("bold") } }) { 
                        Text("OPCIONES DE: $familiaSeleccionadaVista") 
                    }

                    Div({
                        style { display(DisplayStyle.Grid); gridTemplateColumns("repeat(3, 1fr)"); gap(24.px); width(100.percent) }
                    }) {
                        delitosFiltrados.forEach { delito ->
                            val active = delito.estaActivo
                            Div({
                                style {
                                    padding(24.px); borderRadius(16.px); backgroundColor(if (active) Color.white else Color("#f5f5f5"))
                                    property("border-left", "8.px solid ${if (active) delito.colorHex else "#ccc"}")
                                    display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(16.px)
                                    property("box-shadow", "0px 4px 10px rgba(0,0,0,0.2)")
                                }
                            }) {
                                Div {
                                    B({ style { fontSize(18.px); color(if (active) Color.black else Color.gray) } }) { Text(delito.nombre) }
                                    // --- 🛡️ DOCTRINA DE TRAZABILIDAD TERRITORIAL ---
                                    P({ style { fontSize(13.px); color(Color("#1976D2")); fontWeight("bold"); margin(4.px, 0.px) } }) {
                                        Text("📍 ${delito.comunaAsignadaDisplayName ?: "Global"}")
                                    }
                                    P({ style { color(if (active) Color("#2E7D32") else Color("#C62828")); fontWeight("bold"); margin(8.px, 0.px) } }) {
                                        Text(if (active) "🟢 OPERATIVO" else "🔴 DESACTIVADO")
                                    }
                                }
                                Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(12.px); property("margin-top", "auto") } }) {
                                    if (esAdminTotal) {
                                        Div {
                                            B({ style { fontSize(11.px); color(Color.gray) } }) { Text("TRANSFERIR A:") }
                                            Select({
                                                style { width(100.percent); padding(6.px); marginTop(4.px); borderRadius(4.px) }
                                                onChange { viewModel.onCambiarFamiliaDelito(delito, it.target.value) }
                                            }) {
                                                familiasExistentes.forEach { f -> Option(f, attrs = { if (f == delito.familia) selected() }) { Text(f) } }
                                            }
                                        }
                                    }
                                    Button(attrs = {
                                        onClick { viewModel.onCambiarEstadoDelito(delito, active) }
                                        style { padding(8.px); cursor("pointer"); borderRadius(6.6.px); border(0.px); fontWeight("bold"); backgroundColor(if (active) Color("#ffeef0") else Color("#f6ffed")); color(if (active) Color("#cf1322") else Color("#389e0d")) }
                                    }) { Text(if (active) "Desactivar" else "Activar") }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
